import { Box,   Grid, Typography, useMediaQuery } from "@mui/material";
import "../HrSolution/HrSolution.css";
import React from "react";
import Images from "../../constant/images";
import Icon from "../../components/Elements/Icon/Icon";
import "./Service.css";
import { useTranslation } from "react-i18next";
import Card from "../../components/Elements/Card/Card";

const images = [
  Images.servicehader1,
  Images.servicehader2,
  Images.servicehader3,
  Images.servicehader4,
];
const cardData2 = [
  {
    id: 1,
    title: "White labelling & Branding",
    description:
      "Create your organization to offer various courses, build a community, conduct and enhance your team members learning experience under your brand name and theme.",
  },
  {
    id: 2,
    title: "User Management",
    description:
      "Manage and control the role of every user and set privileges for them so that they can focus on what has assigned to them instead of worrying about other woes, which eventually improve their productivity.",
  },
  {
    id: 3,
    title: "Course Management",
    description:
"Add multimedia to create a learning material rich and engaging for learners, which not only make the learning interactive but also enhance their learning ability and maintain the retention rate."  },
  {
    id: 4,
    title: "Assessment & Quiz Management",
    description:
"Create multiple types of questions to conduct the quizzes and assessments which reinforce the learning process and for educators provide a track on learners’ performances."
},
  {
    id: 5,
    title: "Email & In-App Notification",
    description:
    "Connect and communicate with your team member from anywhere, anytime. Get real time updates on the latest happenings in your organization."
  },
  {
    id: 6,
    title: "Branded Mobile App",
    description:
    "Build a ubiquitous connection with your team by launching the dedicated mobile app in your institution name without worrying about the technical knowledge."
  },
];
const cardData = [
  {
    id: 1,
    title: "Mobile Money/E-Wallet",
    description:
      "An exceptional digital payment ecosystem, offering a wide array of features including peer-to-peer transactions, effortless contactless payments, convenient airtime recharges, NFC, and QR code to enhance customer engagement and satisfaction.",
  },
  {
    id: 2,
    title: "Prepaid Card",
    description:
      "Simplify the intricate processes involved in issuing, activating, and managing prepaid cards with our intuitive and user-friendly platform, empowering users with greater control and accessibility. Our range of prepaid cards supports open loop, closed loop, and semi-open loop.",
  },
  {
    id: 3,
    title: "OCR for Documentation",
    description:
      "Enables businesses to extract data from customer documents quickly and accurately, reducing the time and cost associated with manual data entry.",
  },
  {
    id: 4,
    title: "E-KYC/Onboarding",
    description:
      "Streamline the customer onboarding journey, bolstering security measures and ensuring compliance while minimizing friction and enhancing the overall experience for customers",
  },
  {
    id: 5,
    title: "Agency Banking",
    description:
      "Enabling banks to extend their reach and services to underserved areas through a reliable and scalable agency banking solution, facilitating financial inclusion and fostering rapid expansion of the customer base.",
  },
  {
    id: 6,
    title: "International Remittance",
    description:
      "A comprehensive solution for cross-border payments, ensuring speed, cost-effectiveness, interoperability, and transparency in transactions, thus fostering seamless global financial connectivity.",
  },
];
const Service = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <>
      <Box textAlign={"center"}className="responsive-destop">
        <Box className="box-icon">
          <Typography
            variant="h4"
            fontWeight={700}
            textAlign={"center"}
            sx={{ margin: "40px auto 0px" }}
            gutterBottom
            mt={5}
            className="hr-main-heading "
          >
            {t("hrSolution.title")}
          </Typography>
          <Typography
            variant="h4"
            fontWeight={700}
            textAlign={"center"}
            sx={{ margin: " auto " }}
            gutterBottom
            mt={5}
            className="hr-main-heading "
          >
            {t("hrSolution.title2")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              // maxWidth: "00px",
              margin: "0 auto",
              display: "inline-block",
              pb: 1,
              position: "relative",
              zIndex: 1,
              mt: 2,
              width: "55%",
            }}
            className="hr-main-para"
          >
            {t("hrSolution.description")}
          </Typography>
        </Box>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          sx={{ position: "relative", zIndex: 0 }}
          className="mr"
        >
          {images.map((src, index) => (
            <Grid
              item
              xs={6}
              sm={4}
              md={3}
              key={index}
              sx={{ position: "relative", display: "flex" }}
            >
              <img
                src={src}
                alt={`Team ${index + 1}`}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  position: "relative",
                  zIndex: 0,
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>



<Box textAlign={"center"} className="responsive-mob">
        <Box className="box-icon-responsive">
          <Typography
            variant="h4"
            fontWeight={700}
            textAlign={"center"}
            sx={{ margin: "40px auto 0px" }}
            gutterBottom
            mt={5}
            className="hr-main-heading-responsive"
          >
            {t("hrSolution.title")}
          </Typography>
          <Typography
            variant="h4"
            fontWeight={700}
            textAlign={"center"}
            sx={{ margin: " auto " }}
            gutterBottom
            mt={5}
            className="hr-main-heading-responsive "
          >
            {t("hrSolution.title2")}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              // maxWidth: "00px",
              margin: "0 auto",
              display: "inline-block",
              pb: 1,
              position: "relative",
              zIndex: 1,
              mt: 2,
              width: "55%",
            }}
            className="hr-main-para-responsive"
          >
            {t("hrSolution.description")}
          </Typography>
        </Box>
        <Box
          // container
          // spacing={2}
          justifyContent="center"
          sx={{ position: "relative", zIndex: 0 }}
          className="mr-responsive"
        >
          {images.map((src, index) => (
            <Box
              // item
              // xs={6}
              // sm={4}
              // md={3}
              key={index}
              sx={{ position: "relative", display: "flex" }}
            >
              <img
                src={src}
                alt={`Team ${index + 1}`}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  position: "relative",
                  zIndex: 0,
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      <Box className="hr-consultancy-container">
        <Box className="header-section">
          <Box className="empower-section" mt={3}>
            <Box className="empower-sevtion-iconbox">
              <Icon src={Images.hrsolutionvideoicon} alt={""}></Icon>
              <Box
                mt={4}
                display={"flex"}
                flexDirection={"column"}
                gap={"20px"}
                textAlign={"left"}
              >
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 Enterprise Solutions                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    Unlock business value with our tailored, competitive, and efficient technical solutions. Product-based Agile squads, ERP management, and digital transformation enablement.
                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 Quality Analysis & Testing              </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    Our team of certified experts follows a meticulous QA testing life cycle to ensure the applications meet the highest standards, leaving a lasting impact on your users.                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 AI & ML Solutions                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    We offer scalable, on-demand AI &ML solutions via cloud-based platforms as well as in-house servers which help in reducing costs, faster deployment, and enhanced data security.
                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 Data Visualisation                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    Leverage your business data for business expansion & growth. Using PowerBi  & Tableau we create analytical reports and performance visualizations to attain enhanced reporting system.
                  </Typography>
                </Box>
              </Box>
              <Box className="empower-sevtion-iconbox2-responsive">
                  <Icon src={Images.hrsolutionvideoicon2} alt={""} ></Icon>
                </Box>
            </Box>
            <Box className="empower-sevtion-iconbox2">
              <Typography className="header-section-heading ">
                {/* {t("hrSolution.weEmpower")}      */}
                Our IT Services
              </Typography>
              <Box
                mt={4}
                display={"flex"}
                flexDirection={"column"}
                gap={"20px"}
              >
                <Box className="highlighted-text ">
                  <Typography className="hr-heading">
                    Web App Development
                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    Impressive and fully responsive website development that
                    drives tangible leads to the business. Our experts help
                    brands with the ever-changing digital landscape.
                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                <Typography className="hr-heading">
                 Mobile App Development                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    Well-structured UI/UX, responsive and user-friendly mobile app to create seamless user experiences, enabling customers to come again and again.
                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 UI/UX Services                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    UX drives UI. Our experienced team of UX designers collaborate the finer modules of usability and functionality in-line with business goals and end-user needs.
                  </Typography>
                </Box>
                <Box className="highlighted-text ">
                 <Typography className="hr-heading">
                 Full stack Development                  </Typography>

                  <Typography className="hr-paragraph">
                    {/* {t("hrSolution.section1")} */}
                    We work on different front-end technologies like JavaScript, HTML, CSS, & backend technologies like PHP, Node, Java, Python, etc., and expertise in database and server management.
                  </Typography>
                </Box>
                <Box className="empower-sevtion-iconbox2-destop">
                  <Icon src={Images.hrsolutionvideoicon2} alt={""} ></Icon>
                </Box>
                
              </Box>
            </Box>
          </Box>
        </Box>
        <Box textAlign={"center"}>
          <Typography
            fontWeight={700}
            mt={5}
            mb={0}
            className="hr-heading-center"
          >
            Our Fintech Solution
            {/* {t("hrSolution.growFaster")} */}
          </Typography>

          <Box className="solution-box">
  <Box display="flex" flexWrap="wrap" justifyContent="space-between">
    {cardData.map((card: any) => (
      <Box key={card.id} width={{ xs: "100%", sm: "48%", md: "32%" }} mb={2}>
        <Card className="solution-card">
          <Typography className="solution-headding">{card.title}</Typography>
          <Typography className="solution-para" mt={2}>
            {card.description}
          </Typography>
        </Card>
      </Box>
    ))}
  </Box>
</Box>

        </Box>
      </Box>
      <Box  className="eLearning Solution"  >
        <Box  width={isMobile?"100%":"50%"} >
          <Typography className="hr-heading-left">
            eLearning Solution
          </Typography>
          <Typography className="hr-para-left">
            A perfect eLearning software for a fast growing organization
          </Typography>
          <Typography className="hr-para2-left" mt={1} mb={2}>
            Our eLearning platform offers a comprehensive suite of tools to
            create, manage, and deliver online training and educational content.
            With features like course creation, assessment tools, and virtual
            classrooms, our platform supports engaging and effective learning
            experiences for individuals and organizations worldwide.
          </Typography>
          <Icon src={Images.hrsolutionicon} alt={""} style={{width:"100%"}}></Icon>
        </Box>
        <Box width={isMobile?"100%":"50%"} className="eLearning-card-container">
          {cardData2.map((card: any) => (
            <Box key={card.id} className="eLearning-card">
              {" "}
              {/* 50% width with some gap */}
              <Card className="solution-card2">
                <Typography className="solution-headding2" >
                  {card.title}
                </Typography>
                <Typography className="solution-para" mt={2}>
                  {card.description}
                </Typography>
              </Card>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
export default Service;